export const lightTheme = {
  colors: {
    background: "#ffffff",
    accent: "#00B091",
    primary: "#b8d8e9",
    primary_100: "#d0e1fd",
    secondary: "#00527A",
    darkBlue: "#1B263B",
    lightGrey: "#EBEDF0",
    mediumGrey: "#a9adb0",
    darkGrey: "#979A9D",
    borderColor: "#EBEDF0",
    inputBorderMedium: "#d1d5db",
    inputBorder: "#ced4da",
    chartGrid: "#EBEDF0",
    text: "#000000",
    textSecondary: "#4b5563",
    iconSecondary: "#6c757d",
    iconHover: "#3b82f6",
    placeholder: "#93969a",
    select: "#e3f3fc",
    white: "#ffffff",
    scrollbar: "#eaebee",
    scrollbarHover: "#d2d4d8",
    menuBorder: "#efefef",
    menuBackground: "#f9f9f9",
    menuIcon: "#6c757d",
    logo: "#1B263B",
    logoAccent: "#4b86ca",
    treeNodeHover: "#f1f3f5",
    toggleIcon: "#6b7280",
    chip: "#e5e7eb",
    button: "#00527A",
    buttonHover: "#b8d8e9",
    buttonText: "#374151",
    stepDot: "#b0dcf4",
    pipeStroke: "#787C81",
    casingStroke: "#787C81",
    chartHatch: "#6c757d",
    stageBadge: "#31353C",
  },
  spacing: {
    small: "10px",
    medium: "20px",
    large: "40px",
    max: "60px",
  },
  padding: {
    small: "10px",
    medium: "20px",
    large: "40px",
    button: "10px 20px",
    body: "20px",
    container: "30px",
  },
  shadow: {
    small: "0 0 6px rgba(0, 0, 0, 0.05)",
    medium: "0 0 6px rgba(0, 0, 0, 0.1)",
    large: "0 0 6px rgba(0, 0, 0, 0.12)",
  },
  borderRadius: {
    small: "6px",
    medium: "20px",
    large: "30px",
  },
  typography: {
    h1: {
      fontSize: "2rem",
      fontWeight: 700,
    },
    h2: {
      fontSize: "1.3rem",
      fontWeight: 600,
    },
    h3: {
      fontSize: "1.2rem",
      fontWeight: 600,
    },
    body: {
      fontSize: "0.9rem",
      fontWeight: 400,
    },
    medium: {
      fontSize: "1rem",
      fontWeight: 500,
    },
    small: {
      fontSize: "0.75rem",
      fontWeight: 400,
    },
  },
};
